import React from "react";
import { Link } from "react-router-dom";

export default function Lockout() {
	return (
		<div className="absolute-center">
			You need to an active subscription to access this page. Click{" "}
			<Link to="/subscribe">
				<b>here</b>
			</Link>{" "}
			to subscribe
		</div>
	);
}
